<template>
<div class="flex w-full vx-row no-gutter justify-center">
   <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    
    <vx-card class="study-card">
      <div class="lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base text-center">
        <h1 class="mb-8 text-primary sentence"><span class="text-success font-bold">{{ sourceContent.stepName }}</span> 학습이 완료되었습니다.</h1>
        <!-- <p class="text-primary mb-4">{{ displayUnitName }}</p> -->
        <vs-button @click="onComplete" color="danger" class="mr-2">종료하기</vs-button>
        <vs-button @click="onNext" color="success">계속 학습진행</vs-button>
      </div>
    </vx-card>
  </div>  
  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'

export default {
  mixins: [StudyMenuMixin],
  components: {
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    displayUnitName () {
      return this.$displayUnitName(this.sourceContent.stepName)
    }
  },
  methods: {
    
    onNext () {
      this.$emit('onStart')
    },
    onComplete () {
      this.$emit('onFinish')
    }
  },
  created () {
  }
}

</script>

